<template>
  <div>
    <SimpleNav />
    <h1>Background</h1>
    <div class>
      <div class="row">
        <div class="col s12 col l4">
          <img src="/Me4.jpg" id="me" class="responsive-img" alt />
        </div>
        <div class="col s12 col l8" id="about-text">
          <div class="container flow-text">
            <p class="flow-text">
              I am a
              <span class="red-text text-darken-4">web developer/designer</span> currently looking to grow and expand my development skills.
              I graduated from Neumont University with a
              <span
                class="red-text text-darken-4"
              >Bachelor of Science in Web Design and Development</span>.
              Before going to college I knew nothing of about coding or technology and have come a long way since then.
              I wasn't sure if I would like web development in the beginning, but I think it's one of the best decisions I have made in my life.
              I am
              <span
                class="red-text text-darken-4"
              >currently</span> searching for jr web developer positions for either front-end or full-stack development.
            </p>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- <hr /> -->
      </div>
      <!-- <h2>Preferences</h2>
      <div class="row">
          <div class="col s4">
              <img src="/tech/csharp.png" width="64px">
              <img src="/tech/js.png" width="64px">
              <img src="/tech/angular.png" width="64px">
              <img src="/tech/react.png" width="64px">
              <img src="/tech/vue.png" width="64px">
          
          </div>

      </div>-->
    </div>
    <Footer />
  </div>
</template>

<script>
import SimpleNav from "@/components/SimpleNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "AboutPage",
  components: {
    SimpleNav,
    Footer
  }
};
</script>

<style >
body {
  /* background-image: none; */
  color: #000;
}
#about-text {
  color: #2e353b;
  /* text-align: left; */
}
a:hover {
  text-decoration: underline;
}
#me {
  height: 450px;
  /* transform: rotate(270deg); */
  /* margin-top: 75px; */
}
</style>
